import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { validationRequests, workflowRequests } from '../../services';
import { useSelector } from 'react-redux';
import { Alert, CustomLoadingOverlay } from '../../components';
import { useNavigate } from 'react-router-dom';

export default function RejectDocuments({
  documentId = null,
  fileId = null,
  height = null,
  handleCloseViewer = null,
}) {
  const [open, setOpen] = React.useState(false);
  const [loadView, setLoadView] = React.useState(false);
  const [reasons, setReasons] = React.useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setReasons('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadView(true);
    //rechazar documento
    await validationRequests
      .SendDocumentValidation({
        Approved: false,
        Comments: reasons,
        Document_Id: documentId,
        ValidateFileComplete: true,
      })
      .then(async (res) => {
        //continuar con el Wf
        await workflowRequests
          .ContinueWorkflow({
            File_Id: fileId,
            Result: 'Rechazado',
            Status: 'Completo',
          })
          .then((res) => {
            setLoadView(false);
            //al terminar mostrar mensaje de OK y redireccionar a la lista de docuemtos a firmar
            Alert(
              {
                icon: 'success',
                title: t('reject_document_done'),
              },
              () => {
                handleClose();
                if (handleCloseViewer) handleCloseViewer();
                navigate('/main/SearchResultComponent', {
                  state: { forceReload: true },
                });
              },
            );
          })
          .catch((err) => {
            setLoadView(false);
            console.log('Error al terminar WF:', err.message, err.response);
            Alert(
              {
                icon: 'error',
                title: '401', //obtener statuscode error,
                text: err.message, //obtener mensaje de error
              },
              () => handleClose(),
            );
          });
      })
      .catch((err) => {
        setLoadView(false);
        console.log('Error al rechazar:', err.message, err.response);
        //Mostrar mensaje de Error
        Alert(
          {
            icon: 'error',
            title: '401', //obtener statuscode error,
            text: err.message, //obtener mensaje de error
          },
          () => handleClose(),
        );
      });
  };

  console.log('file.items?.Id', fileId);

  return (
    <React.Fragment>
      {loadView && <CustomLoadingOverlay active={loadView} text={t('general_loading_message')} />}
      <Button
        sx={{
          height: height && height,
          width: { xs: 130, sm: 135, md: 140, lg: 'auto' },
          padding: '5px 20px',
        }}
        variant="outlined"
        onClick={handleClickOpen}
        disabled={!documentId || !fileId}
      >
        {t('reject')}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => handleSubmit(event),
        }}
      >
        <DialogTitle>{t('reject_document_confirm')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('reject_document_reason')}</DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="reject_document_tf"
            fullWidth
            variant="outlined"
            multiline
            rows={2}
            value={reasons}
            onChange={(e) => setReasons(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="outlined" color="secondary" onClick={handleClose}>
            {t('general_cancel')}
          </Button>
          <Button type="submit" variant="contained">
            {t('reject')}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
